import { createSlice } from "@reduxjs/toolkit";

export const makeSlice = createSlice({
    name: 'makes',
    initialState: {
        value: []
    },
    reducers: {
        add: (state, action) => {
            state.value.push( action.payload );
        },
        addMany: (state, action) => {
            state.value = [ ...state.value, ...action.payload ];
        },
        setMakes: (state, action) => {
            state.value = action.payload;
        }
    }
});

export const { add, addMany , setMakes} = makeSlice.actions;

export default makeSlice.reducer;
